"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentLegacyCommunicator = void 0;

var superagent_1 = __importDefault(require("superagent"));

var __1 = require("../..");

var config_legacy_api_1 = require("../Configs/config.legacy.api");

var PaymentLegacyCommunicator =
/** @class */
function () {
  function PaymentLegacyCommunicator(env) {
    this.env = env;
    this.httpAgent = superagent_1["default"];
  }

  PaymentLegacyCommunicator.prototype.getPaymentRequest = function (securityToken, paymentMethod, encryptedPanData, appName, billingContact, threeDSInfo, billingMethodParams) {
    var _a, _b;

    return __awaiter(this, void 0, void 0, function () {
      var commonParams;
      return __generator(this, function (_c) {
        commonParams = {
          appName: appName,
          security_token: securityToken,
          pan_type: paymentMethod,
          encrypted_pan_data: encryptedPanData,
          fname: billingContact.name.first,
          mname: billingContact.name.middle,
          lname: billingContact.name.last,
          addr1: billingContact.address.address1,
          addr2: billingContact.address.address2,
          city: billingContact.address.city,
          state: billingContact.address.state,
          country: billingContact.address.country,
          zip: billingContact.address.zip,
          phone: (_a = billingContact.contactInfo) === null || _a === void 0 ? void 0 : _a.phone,
          email: (_b = billingContact.contactInfo) === null || _b === void 0 ? void 0 : _b.email
        };
        return [2
        /*return*/
        , __assign(__assign(__assign({}, commonParams), billingMethodParams), threeDSInfo)];
      });
    });
  };

  PaymentLegacyCommunicator.prototype.processLegacyPayment = function (paymentRequest) {
    var _a, _b, _c, _d;

    return __awaiter(this, void 0, void 0, function () {
      var baseUrl, legacyResponse, paymentUrl, httpResponse, e_1, errorSummary, errorDetails;
      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            if (this.env === __1.Env.dummy) {
              return [2
              /*return*/
              , {
                billingToken: ''
              }];
            }

            baseUrl = config_legacy_api_1.LegacyConfig.getBasePaymentUrl(this.env);
            _e.label = 1;

          case 1:
            _e.trys.push([1, 3,, 4]);

            paymentUrl = new URL(baseUrl);
            return [4
            /*yield*/
            , this.httpAgent.post(paymentUrl.toString()).timeout(config_legacy_api_1.LegacyConfig.defaultTimeout).set('Content-Type', 'application/json;charset=utf-8').send(paymentRequest)];

          case 2:
            httpResponse = _e.sent();
            legacyResponse = httpResponse.body;
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _e.sent();
            errorSummary = JSON.stringify(e_1);

            if ((_a = e_1.response) === null || _a === void 0 ? void 0 : _a.req) {
              errorSummary = JSON.stringify(e_1, function replacer(key, value) {
                // Delete request details so that the error can be safely logged
                if (key == 'req') return undefined;else return value;
              });
            }

            if (e_1.timeout) {
              throw new __1.PaymentTimeoutError('Error processing payment: Time-out', __1.PaymentErrorShortCodes.payment_timeout, {
                cause: {
                  message: e_1.message,
                  details: errorSummary
                },
                code: 'BG-35'
              });
            }

            errorDetails = ((_c = (_b = e_1.response) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.message) || ((_d = e_1.response) === null || _d === void 0 ? void 0 : _d.text) || e_1.message;
            throw new __1.PaymentClientError('Error processing payment: ' + errorDetails, __1.PaymentErrorShortCodes.server_tokenization_error, {
              cause: {
                message: e_1.message,
                details: errorSummary
              },
              code: 'BG-2307'
            });

          case 4:
            // Parse response
            return [4
            /*yield*/
            , this.validateLegacyResponse(legacyResponse)];

          case 5:
            // Parse response
            _e.sent();

            if (legacyResponse.redirectUrl) {
              return [2
              /*return*/
              , {
                billingToken: '',
                redirectUrl: legacyResponse.redirectUrl
              }];
            }

            return [2
            /*return*/
            , {
              billingToken: ''
            }];
        }
      });
    });
  };

  PaymentLegacyCommunicator.prototype.validateLegacyResponse = function (response) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!response) {
          throw new __1.PaymentClientError('Internal Error', __1.PaymentErrorShortCodes.server_tokenization_error, {
            details: "Invalid server response: ".concat(response),
            code: 'BG-2308'
          });
        }

        if (!response.rtn_code && !response.rtn_msg) {
          throw new __1.PaymentClientError('Internal Error', __1.PaymentErrorShortCodes.server_tokenization_error, {
            details: "Invalid server response: ".concat(response),
            code: 'BG-2309'
          });
        }

        if (response.rtn_code === 'BG-35') {
          throw new __1.PaymentTimeoutError(response.rtn_msg, __1.PaymentErrorShortCodes.payment_timeout, {
            code: response.rtn_code
          });
        } // BG-0 - SUCCESS
        // BG-1050 - pending for 3DSv2


        if (response.rtn_code !== 'BG-0' && response.rtn_code !== 'BG-1050') {
          throw new __1.PaymentClientError(response.rtn_msg, __1.PaymentErrorShortCodes.server_tokenization_error, {
            code: response.rtn_code || 'BG-2'
          });
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  return PaymentLegacyCommunicator;
}();

exports.PaymentLegacyCommunicator = PaymentLegacyCommunicator;